import { PropsWithChildren } from 'react';
import { Path, Svg, SVGProps } from '@react-pdf/renderer';
export interface PDFMicrosoftIconProps extends PropsWithChildren<SVGProps> {
  size?: number;
}
export const PDFMicrosoftIcon = ({
  fill = '#FFF',
  size = 24,
  ...props
}: PDFMicrosoftIconProps) => <Svg width={size} height={size} viewBox="0 0 76 76" {...props} data-sentry-element="Svg" data-sentry-component="PDFMicrosoftIcon" data-sentry-source-file="MicrosoftIcon.tsx">
    <Path fill={fill} fillOpacity="1" strokeLinejoin="round" d="M 19,19L 37,19L 37,37L 19,37L 19,19 Z M 57,19L 57,37L 39,37L 39,19L 57,19 Z M 57,57L 39,57L 39,39L 57,39L 57,57 Z M 19,57L 19,39L 37,39L 37,57L 19,57 Z " data-sentry-element="Path" data-sentry-source-file="MicrosoftIcon.tsx" />
  </Svg>;